import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";

const regions = [
  { name: "Sarıçam", desc: "Ana hizmet bölgemiz olan Sarıçam'da tüm temizlik ve yönetim hizmetlerini sunuyoruz.", path: "/hizmet-bolgelerimiz/saricam" },
  { name: "Çukurova", desc: "Çukurova ilçesinde profesyonel temizlik, yönetim ve ilaçlama çözümleri.", path: "/hizmet-bolgelerimiz/cukurova" },
  { name: "Seyhan", desc: "Seyhan genelinde daire, apartman, ofis ve site temizliği hizmetleri.", path: "/hizmet-bolgelerimiz/seyhan" },
  { name: "Yüreğir", desc: "Yüreğir'de koltuk yıkama, halı yıkama, inşaat sonrası temizlik ve ilaçlama.", path: "/hizmet-bolgelerimiz/yuregir" },
];

export default function HizmetBolgelerimizPage() {
  return (
    <Layout>
      <section className="relative min-h-[360px] md:min-h-[420px] flex items-center">
        <div className="absolute inset-0">
          <img
            src="/assets/images/bolgeler-hero.jpg"
            alt="Day Temizlik Adana hizmet bölgelerimiz"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(3, 27, 63, 0.85), rgba(3, 27, 63, 0.45))' }}></div>
        </div>
        <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
          <div className="max-w-3xl">
            <span className="inline-block bg-accent-500/90 text-background-50 text-xs font-medium px-3 py-1.5 rounded-full mb-4">
              Hizmet Bölgelerimiz
            </span>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-background-50 leading-tight mb-4">
              Adana temizlik hizmet bölgelerimiz
            </h1>
            <p className="text-base md:text-lg text-white leading-relaxed mb-6">
              Day Temizlik Adana, Sarıçam başta olmak üzere Çukurova, Seyhan, Yüreğir ve Adana genelinde profesyonel temizlik hizmetleri sunar.
            </p>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {regions.map((region) => (
              <Link
                key={region.path}
                to={region.path}
                className="group bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/50 hover:border-primary-300 hover:bg-primary-50/30 transition-all"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-primary-50 rounded-lg mb-4 group-hover:bg-primary-100 transition-colors">
                  <i className="ri-map-pin-2-line w-5 h-5 flex items-center justify-center text-primary-500"></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2">
                  {region.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {region.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 group-hover:text-primary-600 transition-colors">
                  Detayları gör
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
